<template>

    <b-modal id="updatePermissions" ref="updatePermissions" hide-footer>
        <div v-if="!this.$store.state.profileData.optin2.optinAgreement">
            <h2 class="text-center">Anmeldung Family News</h2>
            <h5 class="text-center mb-50">Melde dich hier zu den McDonald’s Junior Club Family News an.</h5>

            <div class="mandatory-note text-center">
                <p>* Pflichtfelder bitte ausfüllen</p>
            </div>

            <form>
                <div class="form-row">
                    <div class="form-check">
                        <input class="form-check-input"
                               v-validate="'required'"
                               type="checkbox"
                               id="newsletter"
                               name="newsletter">
                        <label class="form-check-label" for="newsletter">
                            Ich stimme zu, dass die McDonald's Deutschland LLC, Zweigniederlassung München mir
                            Newsletter
                            und allgemeine Informationen zu Family-Themen bei McDonald’s per E-Mail zusendet. Diese
                            Zustimmung kann ich auch nachträglich jederzeit gegenüber der McDonald's Deutschland LLC,
                            Zweigniederlassung München widerrufen. Der Widerruf lässt die Rechtmäßigkeit der
                            Verarbeitung
                            bis zum Widerruf unberührt.
                        </label>
                    </div>
                </div>
            </form>
            <footer class="modal-footer yes-no">
                <button type="button" class="btn btn-link" @click="hideModal">Abbrechen</button>
                <button type="button" class="btn btn-primary" @click="sendData" :disabled="!completed">Absenden</button>
            </footer>
        </div>

        <div v-else>
            <h2 class="text-center">Von Family News abmelden</h2>
            <h5 class="text-center mb-50">Bist du dir sicher, dass du dich von den McDonald’s Junior Club Family News
                abmelden möchtest?</h5>
            <footer class="modal-footer yes-no">
                <button type="button" class="btn btn-link" @click="hideModal">Abbrechen</button>
                <button type="button" class="btn btn-primary" @click="sendData" :disabled="!completed">Ja, von Family
                    News
                    abmelden
                </button>
            </footer>
        </div>

    </b-modal>

</template>
<script>

    import {apiChangeOptins} from "../utils/api";

    export default {
        name: 'profileChangePermissionsComponent',
        computed: {
            completed() {
                return Object.keys(this.fields).every(key => this.fields[key].validated) && Object.keys(this.fields).every(key => this.fields[key].valid)
            }
        },
        methods: {
            hideModal() {
                this.$refs.updatePermissions.hide();
            },
            sendData() {

                let optin2 = !this.$store.state.profileData.optin2.optinAgreement;

                apiChangeOptins({

                    "email": this.$store.state.user.email,
                    "optin1": {
                        "optinAgreement": true,
                        "optinFormId": "string"
                    },
                    "optin2": {
                        "optinAgreement": optin2,
                        "optinFormId": "string"
                    },
                    "optin3": {
                        "optinAgreement": true,
                        "optinFormId": "string"
                    }

                })
                    .then(response => {
                        if (response.data.code === 0) {
                            this.$store.commit('updateProfileChangePermissions', optin2);
                            this.$toasted.success('Deine Einstellungen wurden erfolgreich geändert', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                            this.hideModal();

                        } else if (response.data.code === 1)
                            this.$toasted.error('E-Mail-Adresse unbekannt', {
                                duration: 3000,
                                position: 'bottom-right'
                            });

                        else if (response.data.code === 2)
                            this.$toasted.error('Opt-In nicht änderbar', {
                                duration: 3000,
                                position: 'bottom-right'
                            });

                        else if (response.data.code === 99)
                            this.$toasted.error('Pflichtfeld nicht gefüllt', {
                                duration: 3000,
                                position: 'bottom-right'
                            });

                        else
                            this.$toasted.error(response.data.message, {
                                duration: 3000,
                                position: 'bottom-right'
                            });

                    })
                    .catch(e => {
                        console.log('ERROR: ', e);
                        this.$store.commit('error', e);
                    });
            },
            valid(name) {
                return this.fields[name] && this.fields[name].touched && !this.fields[name].valid
            }
        }
    };
</script>
